// extracted by mini-css-extract-plugin
module.exports = {"vPrimary3":"#4f47d7","vGray1":"#83929c","label":"label_label__3TY69","labelWhite":"label_labelWhite__3pykI","labelBlue":"label_labelBlue__11Gij"};